import { createTheme } from '@mui/material/styles';

export const SILKCART_LOGO = 'https://apis.mysilkcart.com/images/silkcart_logo.png';

const theme = createTheme({
  palette: {
    primary: { main: '#214b45', light: '#e9f1ec', dark: '#173b36' },
    secondary: { main: '#f2c7aa', contrastText: '#214b45' },
    background: { default: '#f7f6f2', paper: '#ffffff' },
    text: { primary: '#203e38', secondary: '#728079' },
    divider: '#e4e9e3',
    success: { main: '#3d7961' },
    warning: { main: '#a66b22' },
  },
  typography: {
    fontFamily: '"Nunito", "Segoe UI", sans-serif',
    h4: { fontWeight: 800, letterSpacing: '-1px' },
    h5: { fontWeight: 800, letterSpacing: '-0.5px' },
    h6: { fontWeight: 750 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { borderRadius: 10, padding: '10px 18px' } } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 16 } } },
    MuiCard: { defaultProps: { elevation: 0 }, styleOverrides: { root: { border: '1px solid #e4e9e3' } } },
    MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: '#fff' }, notchedOutline: { borderColor: '#d8e0da' } } },
    MuiTableCell: { styleOverrides: { head: { backgroundColor: '#f6f8f4', color: '#728079', fontWeight: 700 }, root: { borderColor: '#e9ede7' } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 700, borderRadius: 8 } } },
  },
});
export default theme;
